// extracted by mini-css-extract-plugin
module.exports = {"message":"table-info-message_message__bodvU","messageText":"table-info-message_messageText__2TVta"};